import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation } from '@tanstack/react-query';

import { exportLHC } from '../api';

const downloadFile = (blob: Blob, filename: string): void => {
  const windowUrl = window.URL || window.webkitURL;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const objectUrl = windowUrl.createObjectURL(
    new Blob([blob], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
  );

  anchor.href = objectUrl;
  anchor.download = filename.endsWith('.xlsx') ? filename : filename.replace(/\.xls$/, '.xlsx');
  anchor.click();

  document.body.removeChild(anchor);
  windowUrl.revokeObjectURL(objectUrl);
};

export const useLHCExportMutation = () => {
  const token = useAuthStore((s) => s.access_token);

  const exportMutation = useMutation({
    mutationFn: (id: string) => exportLHC(token, id),
    onSuccess: (data) => {
      downloadFile(data.data, data.filename);
    },
    onError: (error) => {
      console.error('Export error:', error);
    },
  });

  return {
    exportLHC: exportMutation.mutateAsync,
    isExporting: exportMutation.isPending,
    exportError: exportMutation.error,
  };
};
